var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg"},[_c('el-empty',{attrs:{"description":"这里什么都没有"}}),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","justify-content":"center"}},[_c('el-button',{on:{"click":_vm.goHome}},[_vm._v("返回首页")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e87ce43","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Notfound.vue
// module id = null
// module chunks = 